import { memo, useMemo } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { StepCard } from "./OneStepCard";
import { colors } from "@/utils/const";
import CustomText from "./text";
import { useI18n } from "@/i18n/I18nProvider";

const WRAPPER_SX = { bgcolor: "#fff" };

const TITLE_BOX_SX = {
  maxWidth: { xs: "100%", md: "70%", lg: "65%", xl: "55%" },
  margin: "auto",
  textAlign: "center",
};

const TITLE_TEXT_STYLE = {
  color: colors.orange,
  fontWeight: "700",
  mb: 1,
  lineHeight: 1,
};

function StepsRow({
  steps = [],
  title,
  titleType = "h2",
  subtitle,
  subtitleType = "body1",
  pageTitle,
}) {
  const { locale } = useI18n();
  const normalizedSteps = useMemo(() => {
    return steps.map((item, idx) => ({
      number: Number(item.step ?? item.number ?? idx + 1),
      title: item.title?.text?.[locale] ?? item.title ?? "",
      titleType: item?.title?.text?.type || "h3",
      Icon: item.Icon,
      __key: item.id ?? item.key ?? idx,
    }));
  }, [steps, locale]);
  return (
    <Box
      className="horizontal-safe-padding vertical-safe-padding"
      data-aos="fade-up"
      data-aos-delay="300"
      sx={WRAPPER_SX}
    >
      {!!title && (
        <Box sx={TITLE_BOX_SX}>
          <CustomText
            text={title}
            type="xxl"
            customStyle={TITLE_TEXT_STYLE}
            variant={titleType || "h2"}
          />
          {!!subtitle && (
            <CustomText
              text={subtitle}
              type="xs"
              customStyle={{ mb: 4 }}
              variant={subtitleType || "body1"}
            />
          )}
        </Box>
      )}

      <Grid container spacing={{ xs: 2 }} justifyContent="center" pt={2}>
        {normalizedSteps.map((s) => {
          const showIcon = Boolean(s.Icon);

          return (
            <Grid
              key={s.__key}
              item
              xs={12}
              sm={12}
              md={6}
              lg={3}
              display="flex"
              justifyContent="center"
            >
              <StepCard
                number={s.number}
                title={s.title}
                titleType={s.titleType}
                Icon={s.Icon}
                pageTitle={pageTitle}
                showIcon={showIcon}
                showStepLabel={!showIcon}
              />
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}

export default memo(StepsRow);
